import { isAxiosError } from "axios";
import type { TFunction } from "i18next";

import { saveErrorSchema } from "../schemas";

const SEGMENT_NAME_CONFLICT_TITLE = "Segment.NameConflict";
const NAME_PROPERTY = "name";
const ERROR_CODE_PATTERN = /^[A-Z][A-Z_]*$/;
const ERROR_CODE_MUST_BE_UNIQUE = "MUST_BE_UNIQUE";

export const getNameErrorCode = (error: unknown): string | undefined => {
  if (!isAxiosError(error)) return undefined;
  const parsed = saveErrorSchema.safeParse(error.response?.data);
  if (!parsed.success) return undefined;
  if (!Array.isArray(parsed.data)) {
    return parsed.data.title === SEGMENT_NAME_CONFLICT_TITLE
      ? ERROR_CODE_MUST_BE_UNIQUE
      : undefined;
  }
  const nameError = parsed.data.find((item) => item.propertyName === NAME_PROPERTY);
  return [nameError?.errorMessage, nameError?.errorCode].find(
    (code): code is string => !!code && ERROR_CODE_PATTERN.test(code),
  );
};

export const getNameErrorMessage = (t: TFunction, error: unknown): string | undefined => {
  const code = getNameErrorCode(error);
  if (!code) return undefined;
  return t(`errorCodes.${code}`, { fieldName: t("common.name") });
};
